<!-- ========== Left Sidebar Start ========== -->
<div class="left-side-menu">

  <div class="h-100" data-simplebar>

    <!--- Sidemenu -->
    <div id="sidebar-menu">

      <ul id="side-menu">
        <p>
          main menu

          <a class="button-menu-mobile bmm-close">
            <i class="mdi mdi-close"></i>
          </a>
        </p>
        <li>
          <a href="javascript:void();" routerLink="/change-password">
            <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/change-password.svg">
            change password
          </a>
        </li>
        <li>
          <a href="javascript:void();" routerLink="/reports/account-statement">
            <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/account-statement.svg">
            account statement
          </a>
        </li>
        <li>
          <a href="javascript:void();" routerLink="/reports/profit-loss">
            <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/profit-loss-report.svg">
            profit loss report
          </a>
        </li>
        <li>
          <a href="javascript:void();" routerLink="/reports/unsettled-bets">
            <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/unsettle-bet.svg">
            unsettled bet
          </a>
        </li>
        <li>
          <a href="javascript:void();" routerLink="/stake-setting">
            <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/set-button-value.svg">
            set button value
          </a>
        </li>
        <li>
          <a href="javascript:void();" routerLink="/market-analysis">
            <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/bet-history.svg">
            market analysis
          </a>
        </li>
        <li>
          <a href="javascript:void();" routerLink="/rules">
            <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/rules.svg">
            rules
          </a>
        </li>
        <li>
          <a href="javascript:void();" (click)="logOut()">
            <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/log-out.svg">
            logout
          </a>
        </li>
      </ul>

    </div>
    <!-- End Sidebar -->

    <div class="clearfix"></div>

  </div>
  <!-- Sidebar -left -->

</div>
<!-- Left Sidebar End -->